module.exports = __webpack_public_path__ + "static/media/purificadores-everest.badb7a8a.webp";